module.exports = __webpack_public_path__ + "img/logo.2e3f0a63.svg";